import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../shared/toast/toast.component';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { AlertService } from '../services/alert.service';
import { Alert } from '../shared/models/alert.model';
import { User } from '../shared/models/user.model';
import { Commission } from '../shared/models/commission.model';
import { ee, perPage30 } from '../shared/constants';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
  standalone: false
})
export class AlertsComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  private userService = inject(UserService);
  private alertService = inject(AlertService);
  toast = inject(ToastComponent);


  @Input() commissions: Commission[] = [];

  isLoading = true;
  perPage = perPage30;
  // Filters
  name = '';
  user = '';
  status = 'on';
  // Alerts
  users: User[] = [];
  alerts: Alert[] = [];
  count = 0;
  page = 0;

  ngOnInit(): void {
    ee.on('changeContent', (data: string) => this.changeContentFn(data));
    ee.on('getAlerts', (page?: number) => this.getAlerts(page));
    this.getUsers();
    this.getAlerts();
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    ee.off('getAlerts', () => {});
  }

  changeContentFn(content: string): void {
    this.resetFilters();
    switch (content) {
      case 'alerts':
        this.user = '';
        this.status = 'on';
        this.getAlerts();
        break;
      case 'my-alerts':
        this.user = this.auth.currentUser._id;
        this.status = '';
        this.getAlerts();
        break;
    }
  }

  resetFilters(): void {
    this.name = '';
    this.user = '';
    this.status = 'on';
  }

  getUsers(): void {
    this.userService.search({ disabled: '0' })
      .subscribe({
        next: res => this.users = res.results,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  getAlerts(page?: number): void {
    this.isLoading = true;
    this.page = page || 0;
    const params = {
      name: this.name,
      _user: this.user,
      _users: this.user,
      status: this.status,
      page: this.page,
      perPage: this.perPage,
    };
    this.alertService.search(params)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: res => {
          this.alerts = res.results;
          this.count = res.count;
        },
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
